<template>
  <div :class="['text-tooltip',textRight?'text-right':'']">
    <!-- @mouseover="onMouseOver" -->
    <span :class="textRows===1?'art_item_row1':'text_item_row2'" ref="NormalTooltip" :title="isSupport && (toolTipCustomText || contentData) "  @mouseover="setToolTip">
      <slot></slot>
      <template v-if="!hasSlot" >
        {{ contentData }}
      </template>
    </span>
  </div>
</template>

<script>
// import { debounce } from 'lodash'
export default {
  name: 'normalTooltip',
  props: {
    content: {},
    alwayShow: Boolean,
    textRight:false,
    textRows:{
      type: Number,
      default:1
    },
    toolTipCustomText: String, // 自定义提示文案
  },
  data() {
    return {
      isSupport: false,
      debounceSetToolTip: null
    }
  },
  mounted() {
  },
  computed: {
    hasSlot() {
      return this.$slots.default && this.$slots.default.length
    },
    contentData() {
      if (this.content) {
        return this.content;
      } else if (this.hasSlot) {
        return this.$slots.default?.[0]?.text
      }
    }
  },
  methods: {
    setToolTip() {
      this.$nextTick(() => {
        // const dom = e.target;
        const dom = this.$refs.NormalTooltip;
        let scrollSize = this.textRows === 1 ? dom?.scrollWidth : dom?.scrollHeight;
        let offsetSize = this.textRows === 1 ? dom?.offsetWidth : dom?.offsetHeight;
        if (this.alwayShow) {
          this.isSupport = true;
        } else if (scrollSize>offsetSize) {
          this.isSupport = true;
        } else {
          this.isSupport = false;
        }
        this.$emit('change', this.isSupport);
      })
    }
    
  },
  watch: {
    content: {
      handler() {
        this.setToolTip();
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.text-tooltip {
  display: inline-flex;
  align-items: center;
  overflow: hidden;
  max-width: 100%;
  .art_item_row1{
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
    width: 100%;
  }
  .text_item_row2{
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }
}
.text-right{
  justify-content: flex-end;
}
</style>
